var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 58.5102,
    rx: 8,
    fill: "#FFEECC",
    fillOpacity: 0.958352
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2238 35.116C50.2238 24.7508 42.1868 16.2273 32.0172 15.45V10.0759H28.9828V15.45C18.8131 16.2276 10.7761 24.7508 10.7761 35.116V38.2554H50.2238V35.116ZM47.1894 35.221H13.8106V35.116C13.8106 25.9135 21.2974 18.4266 30.5 18.4266C39.7026 18.4266 47.1894 25.9134 47.1894 35.116V35.221ZM7.7417 41.9375H53.2583V44.972H7.7417V41.9375Z",
    fill: "#A77C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.08c8a7531ddb59d5b5b2bda681417d19.svg";
export { ForwardRef as ReactComponent };